export const slugRegex = /[*+~.,^#()$&/;=?'"„!\\:@{}«»[\]]/g;
export const emojiRegex = require('emoji-regex'); // it has global flag ('/g') inside of it
